export const DEFAULT_BASE_URL = 'https://safe-client.gnosis.io'
